import { isEmpty } from 'lodash';
import React from 'react';
import ForecastReturnsTable from './components/ForecastReturnsTable';
import { calcNearestStep } from './util';

const MorningstarForecastReturns = ({
  currentRiskAndReturn,
  defaultRiskAndReturn,
  customRiskAndReturn,
  setValues,
  saveTables,
  isSaving,
  isFirmAdmin,
  isCustom
}: any) => {
  const convertToTitleCase = (str: string) => {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const updateValues = (
    enumValue: any,
    riskLevel: any,
    value: any,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    type: any
  ) => {
    const savedValues = customRiskAndReturn as any;
    savedValues[riskLevel] = calcNearestStep(value / 100, 0.0001);
    setValues({ ...savedValues } as any);
  };

  const keyOrder = [
    'lowest',
    'very_low',
    'low',
    'average',
    'high',
    'very_high',
    'highest'
  ];

  const orderValues = (a: string, b: string) =>
    keyOrder.indexOf(a) - keyOrder.indexOf(b);

  return (
    <>
      {!isEmpty(currentRiskAndReturn) && (
        <ForecastReturnsTable
          riskLevelDescriptions={Object.keys(currentRiskAndReturn)
            .sort(orderValues)
            .map((key: string) => ({
              risk_level: key,
              risk_type: convertToTitleCase(key)
            }))}
          displayRiskLevel={false}
          returnAndRisk={currentRiskAndReturn}
          defaultRiskAndReturn={defaultRiskAndReturn}
          updateValues={updateValues}
          saveTables={saveTables}
          isSaving={isSaving}
          isFirmAdmin={isFirmAdmin}
          isCustom={isCustom}
          hasRisk={false}
        />
      )}
    </>
  );
};

export default MorningstarForecastReturns;
